import api from 'api/api'
import queryClient from 'api/queryClient'
import { QUEST_ENTITY_QUERY_POLICY } from 'api/queryPolicies'
import { doesStreamQuestNeedHydration } from 'refactor/hooks/api/streamQuestHydration'
import { getCachedQuest } from 'state/cache'
import { createStreamQuestHydrationQueue } from 'state/streamQuestHydrationQueueCore'

const streamQuestHydrationQueue = createStreamQuestHydrationQueue({
    hydrateQuest: questId =>
        queryClient.fetchQuery({
            queryKey: ['quest', questId],
            queryFn: async ({ signal }) => {
                const quest = await api.getQuestQuery(
                    questId,
                    { skipStreamQueryTouch: true, streamPreview: true },
                    signal,
                )
                if (quest) return quest

                const localQuest = getCachedQuest(questId)
                if (localQuest && !doesStreamQuestNeedHydration(localQuest)) return localQuest

                const error = Object.assign(new Error('Quest not found'), { status: 404 })
                throw error
            },
            gcTime: QUEST_ENTITY_QUERY_POLICY.gcTime,
            // The normalized Answer entities can be evicted while the raw Quest query remains
            // fresh. The queue has already proved this Quest is under-hydrated, so force the
            // shared query to refill it and let mounted useGetQuest observers dedupe against it.
            retry: false,
            staleTime: 0,
        }),
    needsHydration: questId => {
        const quest = getCachedQuest(questId)
        return !quest || doesStreamQuestNeedHydration(quest)
    },
})

export const queueStreamQuestHydration = streamQuestHydrationQueue.queueStreamQuestHydration
